import React, {useEffect, useState} from "react";
import {useDirectus} from "../../app/DirectusProvider";
import {Link} from "react-router-dom";
import moment from "moment";
import Title from "../common/Title";
import DefaultGrid from "../common/DefaultGrid";
import Presence from "../../app/config/Presence";
import {toast} from "react-toastify";
import {loadSpinner} from "../../utils/helpers";
import {useTranslation} from "react-i18next";
import {motion} from "framer-motion"

const CoursList = ({historique}) => {
    const directus = useDirectus();
    const [cours, setCours] = useState([]);
    const {t} = useTranslation();

    useEffect(() => {
        //TODO Suivre le développement de Directus pour voir si le problème de filtre et fuseau horraire est réglé
        const now = moment().format("Y-MM-DD");
        const filter = {'date': historique ? {'_lt': now} : {'_gte': now}};
        toast.dismiss();
        loadSpinner(
            new Promise((resolve, reject) => {
                directus.items("cours").readByQuery({
                    fields: ["id", "date", "groupe.nom", "enfants.presence", "entraineurs.directus_users_id.first_name", "entraineurs.directus_users_id.last_name", "entraineurs.directus_users_id.display_name"],
                    filter: filter,
                    sort: [`${historique ? "-" : ""}date`, "groupe.numero"]
                }).then((resp) => {
                    setCours(resp.data);
                }).catch(() => {
                    reject();
                }).finally(() => {
                    resolve();
                });
            })
        );
    }, [directus, historique]);

    return (
        <>
            <Title title={t("coursList.titre")}/>
            {cours.length < 1 &&
                <div
                    className={"text-center w-full absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2"}>
                    {t("coursList.vide")}
                </div>}
            <DefaultGrid>
                {cours.map((c, idx) => {
                    return (
                        <motion.div initial={{opacity: 0, y: -15}} animate={{opacity: 1, y: 0}}
                                    transition={{duration: 0.25, delay: 0.1 * idx}} key={`cours-list-item-${idx}`}>
                            <Link to={`/cours/${c.id}`} className={`grid grid-cols-12 p-3 rounded-lg shadow-lg`}>
                                <div className={"col-span-10"}>
                                    {`${c.date ? moment(c.date, "YYYY-MM-DD").format("DD.MM.YYYY") : ""} ${c.groupe?.nom ? ` – ${c.groupe?.nom}` : ""}`}
                                    <div>
                                        {c.entraineurs?.length > 0 && <span className={"text-xs"}> &nbsp;
                                            {c.entraineurs.map((e, i) => {
                                                return (e.directus_users_id.display_name ? e.directus_users_id.display_name : e.directus_users_id.first_name.substring(0, 4))
                                                    + (i < c.entraineurs.length - 1 ? " & " : "");
                                            })}
                                    </span>}
                                    </div>
                                </div>
                                <div className={"col-span-2 text-right"}>
                                    ({c?.enfants?.filter((e) => e.presence === Presence.present.value).length})
                                </div>
                            </Link>
                        </motion.div>
                    )
                })}
            </DefaultGrid>
        </>
    );
}

export default CoursList;
